import { DefaultScheduleAppointmentTask, IScheduleAppointmentTask } from '../Definitions'
import * as Yup from 'yup'
import moment from 'moment'

export const ScheduleAppointmentTaskSchema = Yup.object().shape({
  authorizationType: Yup.string(),
  comments: Yup.string(),
  completedTime: Yup.string(),
  dateCompleted: Yup.date().transform((value) => (value === '' ? undefined : value)),
  dateCompletedInput: Yup.string(),
  days: Yup.number(),
  id: Yup.string(),
  isActive: Yup.boolean(),
  name: Yup.string(),
  priority: Yup.number(),
  requiresApproval: Yup.boolean(),
  taskNotApplicable: Yup.boolean(),
  timing: Yup.string(),
})

export interface IScheduleAppointmentTaskFormValues {
  authorizationType?: string
  completedTime?: string
  days?: number
  dateCompleted?: Date
  dateCompletedInput?: string
  comments: string
  readonly id: string
  isActive: boolean
  name?: string
  priority?: number
  requiresApproval: boolean
  taskNotApplicable: boolean
  timing?: string
}

function setDefaultValues(): IScheduleAppointmentTaskFormValues {
  return {
    comments: '',
    completedTime: undefined,
    dateCompleted: undefined,
    dateCompletedInput: undefined,
    id: '',
    isActive: true,
    requiresApproval: false,
    taskNotApplicable: false,
  }
}

function setValuesFromScheduleAppointmentTask(
  appointmentTask: IScheduleAppointmentTask
): IScheduleAppointmentTaskFormValues {
  return {
    authorizationType: appointmentTask.authorizationType || '',
    comments: appointmentTask.comments || '',
    completedTime: appointmentTask.dateCompleted
      ? moment(appointmentTask.dateCompleted).format('HH:mm:ss')
      : undefined,
    dateCompleted: appointmentTask.dateCompleted || undefined,
    dateCompletedInput: appointmentTask.dateCompleted
      ? moment(appointmentTask.dateCompleted).format('YYYY-MM-DD')
      : undefined,
    days: appointmentTask.days || 0,
    id: appointmentTask.id || '',
    isActive: appointmentTask.isActive,
    name: appointmentTask.name || '',
    priority: appointmentTask.priority || 0,
    requiresApproval: appointmentTask.requiresApproval,
    taskNotApplicable: appointmentTask.taskNotApplicable,
    timing: appointmentTask.timing || '',
  }
}

export function createIScheduleAppointmentTaskFormValues(
  appointmentTask?: IScheduleAppointmentTask
) {
  if (appointmentTask) {
    return setValuesFromScheduleAppointmentTask(appointmentTask)
  } else {
    return setDefaultValues()
  }
}

export function toScheduleAppointmentTask(
  formValues: IScheduleAppointmentTaskFormValues,
  original?: IScheduleAppointmentTask
): IScheduleAppointmentTask {
  const appointmentTask =
    original === undefined ? DefaultScheduleAppointmentTask() : original

  // Combine date and time into single DateTime object
  let combinedDateTime: Date | undefined = undefined
  if (formValues.dateCompletedInput && formValues.completedTime) {
    combinedDateTime = moment(
      `${formValues.dateCompletedInput} ${formValues.completedTime}`,
      'YYYY-MM-DD HH:mm:ss'
    ).toDate()
  } else if (formValues.dateCompletedInput) {
    combinedDateTime = new Date(
      moment(formValues.dateCompletedInput, 'YYYY-MM-DD').toISOString()
    )
  }

  return {
    ...appointmentTask,
    authorizationType: formValues.authorizationType || '',
    comments: formValues.comments || '',
    dateCompleted: combinedDateTime,
    days: formValues.days || 0,
    isActive: formValues.isActive,
    name: formValues.name || '',
    priority: formValues.priority || 0,
    requiresApproval: formValues.requiresApproval,
    taskNotApplicable: formValues.taskNotApplicable || false,
    timing: formValues.timing || '',
  }
}
